<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "QualityReportActionLayout"
    }
</script>

<style scoped>

</style>
